/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import useCustomizableContext from "~/CustomizableToolPage/useCustomizableContext";

interface Props {
  infoPanelShowing: boolean;
  setInfoPanelShowing: (x: boolean) => void;
  selectedCameraRegion: number;
  setSelectedCameraRegion: (id: number) => void;
}

const Navigation = ({
  infoPanelShowing,
  setInfoPanelShowing,
  selectedCameraRegion,
  setSelectedCameraRegion,
}: Props) => {
  const {
    // selectors
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    getNavigationSpecificData,
  } = useCustomizableContext();

  const navigationData = getNavigationSpecificData();

  return (
    <>
      {(navigationData.length < 5 && (
        <div
          className={`customize__toggle${
            infoPanelShowing ? " panel-open" : ""
          }`}
          id="model-navigation"
        >
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/* @ts-ignore */}
          {navigationData.map((item) => (
            <a
              key={item.id}
              className={`customize__toggle-btn btn${
                selectedCameraRegion === item.id ? " active" : ""
              }`}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setSelectedCameraRegion(item.id);
              }}
            >
              {item.region}
            </a>
          ))}
          <a
            href="#"
            className="customize__toggle-btn customize__toggle-btn--expand btn"
            onClick={(e) => {
              e.preventDefault();
              setInfoPanelShowing(true);
            }}
          >
            <span className="icon icon-question" />
          </a>
        </div>
      )) || (
        <div
          id="model-navigation"
          className={`customize__toggle form${
            infoPanelShowing ? " panel-open" : ""
          }`}
        >
          <div className="form__control-container">
            <select
              className="form__control navigation-select"
              value={selectedCameraRegion}
              onChange={(e) => setSelectedCameraRegion(Number(e.target.value))}
            >
              {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
              {/* @ts-ignore */}
              {navigationData.map((item) => (
                <option
                  className="navigation-option"
                  key={item.id}
                  value={item.id}
                >
                  {item.region}
                </option>
              ))}
            </select>
            <label className="form__label">Currently Viewing</label>
            <span className="form__control-icon form__control-icon--lg icon-down-micro" />
          </div>
          <a
            href="#"
            className="customize__toggle-btn customize__toggle-btn--expand btn"
            onClick={(e) => {
              e.preventDefault();
              setInfoPanelShowing(true);
            }}
          >
            <span className="icon icon-question" />
          </a>
        </div>
      )}
    </>
  );
};

export default Navigation;
